import React from 'react';
import { EditRestaurantControlPanel } from './components/ControlPanel/EditRestaurantControlPanel';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';
import { EditRestaurantState } from './editRestaurantState/EditRestaurantState';

const EditRestaurantPage: React.FC = () => {
	return (
		<EditRestaurantState>
			<EditRestaurantControlPanel />
			<Forms />
			<ModalWindows />
		</EditRestaurantState>
	);
};

export default EditRestaurantPage;
